"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembershipTabs = void 0;
var MembershipTabs;
(function (MembershipTabs) {
    MembershipTabs["Certificate"] = "CERTIFICATE";
    MembershipTabs["Classes"] = "CLASSES";
    MembershipTabs["Content"] = "CONTENT";
    MembershipTabs["Customization"] = "CUSTOMIZATION";
    MembershipTabs["Ebook"] = "EBOOK";
    MembershipTabs["Info"] = "INFO";
    MembershipTabs["Interactions"] = "INTERACTIONS";
    MembershipTabs["Users"] = "USERS";
    MembershipTabs["FreeSignup"] = "FREE_SIGNUP";
    MembershipTabs["Sales"] = "SALES";
    MembershipTabs["Community"] = "COMMUNITY";
    MembershipTabs["Tracks"] = "TRACKS";
})(MembershipTabs || (exports.MembershipTabs = MembershipTabs = {}));
class ClubTabChangeEvent {
}
ClubTabChangeEvent.dispatch = (membershipTab) => {
    window.dispatchEvent(new CustomEvent('clubtabchange', { detail: membershipTab }));
};
exports.default = ClubTabChangeEvent;
